import type { MouseEvent } from 'react';

export function stopCstretchmodalPropagation(event?: MouseEvent): void {
  event?.stopPropagation();
}
